import { useTranslation } from "react-i18next";
import { useSwitch } from "shared/dynamic-imports";
import { IconDispatcher } from "shared/ui-basics";
import styled, { css } from "styled-components/macro";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

interface EditModeSwitchProps {
	addLabel?: string | undefined;
    renderReadOnlyItems?: () => JSX.Element;
	children?: React.ReactNode;
	isEmpty?: boolean;
	isDisabled?: boolean;
}


const EditModeSwitch = ({ addLabel, renderReadOnlyItems, children, isEmpty, isDisabled = false } : EditModeSwitchProps) : JSX.Element => {
	const { t } = useTranslation();
	const hideForPdf = useLocation().search.hideForPdf();
	const isReadOnly = useSelector(({ auth }:any) => auth.userInfo.UserType)?.isReadOnly();
    const { isOpen, open } = useSwitch();

	const render = () => {
		if (!isOpen && isEmpty && !hideForPdf){
			if(isReadOnly) return null;
			return (
				<Container onClick={open} disabled={isDisabled}>
					<Label>
						<div>{IconDispatcher("PLUS")}</div>
						<div>{addLabel && t(addLabel)}</div>
					</Label>
				</Container>
			);
		}
		if (!isOpen && renderReadOnlyItems)
			return (
				<Container className="d-flex flex-wrap" onClick={open} disabled={isDisabled}>
					{renderReadOnlyItems()}
				</Container>
			);

		return children;
	};

	return <>{render()}</>;
};

EditModeSwitch.displayName = "EditModeSwitch";
export default EditModeSwitch;

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
    disabled?: boolean
}

const Container = styled.div<ContainerProps>`
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;
	min-height: 49px;
	border-radius: 4px;
	padding: 8px;
	cursor: pointer;
	:hover {
		background: #efefef;
	}
	${(props) =>
		props.disabled &&
		css`
			cursor: not-allowed;
		`}
`;

const Label = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	color: #605f60;
	font-size: 14px;
`;
